export default __webpack_public_path__ + "e4d6592b763beaff20ec13ee8703a475.woff2";